export default __webpack_public_path__ + "static/media/7457 - Harry Lee Media.d7fa0db2.jpeg";